import cx from 'classnames'
import { ButtonContext, type PressEvent } from 'react-aria-components'

import { useTranslate } from '../../../hooks/useTranslate'
import { InsideInputIconButton } from '../insideInputIconButton/InsideInputIconButton'

type ClearButtonProps = {
  onClear: (event: PressEvent) => void
  className?: string
}

/** Clear ("x") button for inputs. Callers decide when it's present; it only becomes visible on hover/focus-within of `clearButtonStyles.group`. */
export const ClearButton = ({ onClear, className }: ClearButtonProps) => {
  const translate = useTranslate()

  return (
    // Opts out of trigger props that e.g. ComboBox and DatePicker give every Button inside them.
    <ButtonContext.Provider value={null}>
      <InsideInputIconButton
        tip={translate('input.clear')}
        iconName="XMark"
        className={cx(
          'invisible group-hover/clearable:visible group-focus-within/clearable:visible',
          className,
        )}
        aria-label={translate('input.clear')}
        excludeFromTabOrder
        preventFocusOnPress
        onPress={onClear}
      />
    </ButtonContext.Provider>
  )
}
